import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { partnerStackSignUp } from '../utils/partnerStackSignUp/partnerStackSignUp';

import config from '../config';

// apis
const login = ({ data }) =>
  axios.post(`${config?.apiHost}/sessions?jwt=1`, data, { withCredentials: true });
const loginSso = ({ data }) =>
  axios.post(`${config?.apiHost}${config?.endpoints?.authSso}`, data, { withCredentials: true });
const resetPassword = ({ data }) =>
  axios.post(`${config?.apiHost}/account/forgotPassword`, data, { withCredentials: true });
const signUp = ({ data }) =>
  axios.post(`${config?.apiHost}/account`, data, { withCredentials: true });
const checkEmailAvailability = ({ data }) =>
  axios.post(`${config?.apiHost}/account/check`, data, { withCredentials: true });
const fetchOrganizationInviteInfoWithToken = ({ queryKey }) =>
  axios.get(`${config?.apiHost}/organizations?invite_token=${queryKey[1]}&pending=true`);
const fetchPlanData = ({ queryKey }) => {
  const couponParam = queryKey[2] ? `?coupon=${queryKey[2]}` : '';
  return axios.get(`${config?.apiHost}/v1/plans/${queryKey[1]}${couponParam}`);
};
const getResetPasswordToken = ({ queryKey }) =>
  axios.get(`${config?.apiHost}/account/resetPassword/${queryKey[1]}`);
const putResetPassword = ({ data }) =>
  axios.put(`${config?.apiHost}/account/resetPassword`, data, { withCredentials: true });

// queries
export const useGetOrganizationInviteData = (inviteToken) =>
  useQuery(['organizationInvite', inviteToken], fetchOrganizationInviteInfoWithToken, {
    staleTime: Infinity,
    enabled: !!inviteToken
  });
export const useGetResetPasswordToken = (resetToken) =>
  useQuery(['resetPassword', resetToken], getResetPasswordToken, {
    staleTime: Infinity,
    enabled: !!resetToken,
    retry: false
  });
export const useFetchPlanData = (plan, coupon = '') => {
  const queryClient = useQueryClient();
  return useQuery(['plan', plan, coupon], fetchPlanData, {
    staleTime: Infinity,
    placeholderData: () => queryClient.getQueryData(['plan', plan, '']),
    retry: false
  });
};
// mutations
export const usePostLogin = () => useMutation(login);
export const usePostLoginSso = () => useMutation(loginSso);
export const usePostResetPassword = ({ onError, onSuccess }) =>
  useMutation(resetPassword, { onError, onSuccess });
export const usePostSignUp = () =>
  useMutation(signUp, {
    onSuccess: (data, variables) => {
      partnerStackSignUp(variables?.data);
    }
  });
export const usePostCheckEmailAvailability = (props) =>
  useMutation(checkEmailAvailability, { ...props });
export const useResetPassword = (props) => useMutation(putResetPassword, { ...props });



// WEBPACK FOOTER //
// ./src/hooks/useAuthData.js